import io from 'socket.io-client';
import config from './config';

export default () => io(config.socketUrl, { transports: ['websocket'], upgrade: false})



// WEBPACK FOOTER //
// ./src/socket.js